/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ first_yearly_price: NonNullable<unknown>, first_monthly_price: NonNullable<unknown> }} Starter_Challenge_Paywall_Footer_YearlyInputs */

const en_starter_challenge_paywall_footer_yearly = /** @type {(inputs: Starter_Challenge_Paywall_Footer_YearlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.first_yearly_price} at first year, equals ${i?.first_monthly_price}/month. Cancel anytime.`)
};

const ar_starter_challenge_paywall_footer_yearly = /** @type {(inputs: Starter_Challenge_Paywall_Footer_YearlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.first_yearly_price} للسنة الأولى، ما يعادل ${i?.first_monthly_price}/شهر. إلغاء في أي وقت.`)
};

const de_starter_challenge_paywall_footer_yearly = /** @type {(inputs: Starter_Challenge_Paywall_Footer_YearlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.first_yearly_price} im ersten Jahr, entspricht ${i?.first_monthly_price}/Monat. Jederzeit kündbar.`)
};

const es_starter_challenge_paywall_footer_yearly = /** @type {(inputs: Starter_Challenge_Paywall_Footer_YearlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.first_yearly_price} el primer año, equivale a ${i?.first_monthly_price}/mes. Cancela cuando quieras.`)
};

const fr_starter_challenge_paywall_footer_yearly = /** @type {(inputs: Starter_Challenge_Paywall_Footer_YearlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.first_yearly_price} la première année, soit ${i?.first_monthly_price}/mois. Annulez à tout moment.`)
};

const it_starter_challenge_paywall_footer_yearly = /** @type {(inputs: Starter_Challenge_Paywall_Footer_YearlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.first_yearly_price} per il primo anno, pari a ${i?.first_monthly_price}/mese. Annulla in qualsiasi momento.`)
};

const ja_starter_challenge_paywall_footer_yearly = /** @type {(inputs: Starter_Challenge_Paywall_Footer_YearlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`初年度 ${i?.first_yearly_price}、${i?.first_monthly_price}/月相当。いつでもキャンセル可能。`)
};

const ko_starter_challenge_paywall_footer_yearly = /** @type {(inputs: Starter_Challenge_Paywall_Footer_YearlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`첫 해 ${i?.first_yearly_price}, ${i?.first_monthly_price}/월 상당. 언제든지 취소 가능.`)
};

const pt_br_starter_challenge_paywall_footer_yearly = /** @type {(inputs: Starter_Challenge_Paywall_Footer_YearlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.first_yearly_price} no primeiro ano, equivale a ${i?.first_monthly_price}/mês. Cancele quando quiser.`)
};

const ru_starter_challenge_paywall_footer_yearly = /** @type {(inputs: Starter_Challenge_Paywall_Footer_YearlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.first_yearly_price} в первый год, что равно ${i?.first_monthly_price}/месяц. Отмена в любое время.`)
};

const th_starter_challenge_paywall_footer_yearly = /** @type {(inputs: Starter_Challenge_Paywall_Footer_YearlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.first_yearly_price} สำหรับปีแรก เท่ากับ ${i?.first_monthly_price}/เดือน ยกเลิกได้ทุกเมื่อ`)
};

const tr_starter_challenge_paywall_footer_yearly = /** @type {(inputs: Starter_Challenge_Paywall_Footer_YearlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`İlk yıl ${i?.first_yearly_price}, aylık ${i?.first_monthly_price}/aya eşdeğer. İstediğiniz zaman iptal edin.`)
};

const zh_cn_starter_challenge_paywall_footer_yearly = /** @type {(inputs: Starter_Challenge_Paywall_Footer_YearlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.first_yearly_price} 首年，等同 ${i?.first_monthly_price}/月。随时可取消。`)
};

const zh_tw_starter_challenge_paywall_footer_yearly = /** @type {(inputs: Starter_Challenge_Paywall_Footer_YearlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.first_yearly_price} 首年，等同 ${i?.first_monthly_price}/月。隨時可取消。`)
};

/**
* | output |
* | --- |
* | "{first_yearly_price} at first year, equals {first_monthly_price}/month. Cancel anytime." |
*
* @param {Starter_Challenge_Paywall_Footer_YearlyInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const starter_challenge_paywall_footer_yearly = /** @type {((inputs: Starter_Challenge_Paywall_Footer_YearlyInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Starter_Challenge_Paywall_Footer_YearlyInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_starter_challenge_paywall_footer_yearly(inputs)
	if (locale === "ar") return ar_starter_challenge_paywall_footer_yearly(inputs)
	if (locale === "de") return de_starter_challenge_paywall_footer_yearly(inputs)
	if (locale === "es") return es_starter_challenge_paywall_footer_yearly(inputs)
	if (locale === "fr") return fr_starter_challenge_paywall_footer_yearly(inputs)
	if (locale === "it") return it_starter_challenge_paywall_footer_yearly(inputs)
	if (locale === "ja") return ja_starter_challenge_paywall_footer_yearly(inputs)
	if (locale === "ko") return ko_starter_challenge_paywall_footer_yearly(inputs)
	if (locale === "pt_br") return pt_br_starter_challenge_paywall_footer_yearly(inputs)
	if (locale === "ru") return ru_starter_challenge_paywall_footer_yearly(inputs)
	if (locale === "th") return th_starter_challenge_paywall_footer_yearly(inputs)
	if (locale === "tr") return tr_starter_challenge_paywall_footer_yearly(inputs)
	if (locale === "zh_cn") return zh_cn_starter_challenge_paywall_footer_yearly(inputs)
	return zh_tw_starter_challenge_paywall_footer_yearly(inputs)
});